import {HeightRule, Table, TableLayoutType, TableRow, WidthType} from "docx";
import Options from "../../../data/options";
import {tableCellHeader, tableCellHeaderHeadline, tableCellWithRowSpanAndImage} from "./tableCell";

export const headerTable1 = (user, klausur, schueler) => {
  return new Table({
    layout: TableLayoutType.FIXED,
    columnWidths: [7000, 2500],
    width: {
      size: 100,
      type: WidthType.PERCENTAGE
    },
    rows: [
      new TableRow({
        height: {value: 350, rule: HeightRule.AUTO},
        children: [
          tableCellHeaderHeadline("Gutachten")
          // tableCellWithRowSpanAndImage("", 1, logo),
        ]
      }),
      new TableRow({
        height: {value: 350, rule: HeightRule.AUTO},
        children: [tableCellHeaderHeadline(`für ${schueler.vorname} ${schueler.nachname}`)]
      }),

      new TableRow({
        height: {value: 350, rule: HeightRule.AUTO},
        children: [
          tableCellHeaderHeadline(
            `${Options.getValue("pruefungsart", klausur.pruefungsart)} ${klausur.date.slice(0, 4)}, ${Options.getValue(
              "kursart",
              klausur.kursart
            )} ${Options.getValue("fach", klausur.fach)}`
          )
        ]
      })
    ]
  });
};

export const headerTable2 = (user, klausur, schueler, companies) => {
  console.log({user, klausur, schueler, companies});
  const isAbitur = klausur.pruefungsart.includes("a");
  const land = companies.find(c => c.id === parseInt(klausur.companyId))?.land;

  const row1 = new TableRow({
    height: {value: 300, rule: HeightRule.AUTO},
    children: [tableCellHeader("Kurs-/ Schulhalbjahr"), tableCellHeader(`${Options.getValue("halbjahr", klausur.halbjahr)}`)]
  });
  const otherRows = [
    new TableRow({
      height: {value: 300, rule: HeightRule.AUTO},
      children: [tableCellHeader("Aufgabenart"), tableCellHeader(`${Options.getValue("aufgabenart", klausur.aufgabenart)}`)]
    }),
    new TableRow({
      height: {value: 300, rule: HeightRule.AUTO},
      children: [
        tableCellHeader(
          `${isAbitur ? (land === "Brandenburg" ? "Gutachter" : Options.getLong("gutachter", klausur.gutachter) || "xy") : "Kursleitung"}:`
        ),
        tableCellHeader(`${user.firstName} ${user.lastName}`)
      ]
    }),
    new TableRow({
      height: {value: 300, rule: HeightRule.AUTO},
      children: [
        tableCellHeader("Schule"),
        tableCellHeader(`${companies.find(c => c.id === parseInt(klausur.companyId))?.name || "undefined"}`)
      ]
    })
  ];

  return new Table({
    layout: TableLayoutType.FIXED,
    columnWidths: [3000, 7000],
    width: {
      size: 100,
      type: WidthType.PERCENTAGE
    },
    rows: klausur.pruefungsart.includes("a") ? [...otherRows] : [row1, ...otherRows]
  });
};
